<div class="flight-search-component-wrap">
    <div class="container form-content-container p-0">
        <ng-container *ngIf="isMock">
            <div class="check-value" (click)="checkValue()">Check value</div>
        </ng-container>
        <form [formGroup]="flightSearchForm" (ngSubmit)="onFormSubmit()" class="form-section">

            <!------  START :: FORM ELEMENTS ----->
            <div class="controls-wrap">
                <!------  START :: DESTINATION FIELD ----->

                <div class="form-group destination-wrap">
                    <label for="destination">
                        {{ pageConstants[destination.label]}}
                        <span *ngIf="destination.isRequired" class="required">({{ commonConstants.required }})</span>
                    </label>
                    <ng-autocomplete #finalDestination
                        id="destination"    
                        [data]="filteredAirports" 
                        [searchKeyword]="keyword"
                        (selected)='onSelectEvent($event)' 
                        (inputChanged)='onDestinationChange($event)'
                        (inputFocused)='onInputFocused($event)' 
                        [itemTemplate]="destinationTemplate"
                        (inputCleared)="inputCleared($event)"
                        formControlName="destination" 
                        [initialValue]="destinationDisplay" 
                        [placeholder]="destinationPlaceholder"
                        class="form-control destination-field" 
                        [minQueryLength]="minQueryLength">
                    </ng-autocomplete>
                    <ng-template #destinationTemplate let-filteredAirport>
                        <a [innerHTML]="filteredAirport.name"></a>
                    </ng-template>
                    <div class="error-block" *ngIf="destinationControl?.dirty && destinationControl?.invalid && !finalDestination?.isFocused">
                        <div class="err-message" *ngIf="destinationControl?.errors?.required" role='alert'>
                            <div class="error-icon">
                                <img src="./../../../assets/error.png" alt="error" />
                            </div>
                            <span>{{ pageConstants[destination.required] }}</span>
                        </div>
                        <div class="err-message" *ngIf="destinationControl?.errors?.pattern" role='alert'>
                            <div class="error-icon">
                                <img src="./../../../assets/error.png" alt="error" />
                            </div>
                            <span>{{pageConstants[destination.error.invalid]}}</span>
                        </div>
                        <div class="err-message" 
                        *ngIf="!destinationControl?.errors?.required && !destinationControl?.errors?.pattern &&
                        destinationControl?.errors?.notChosen" role='alert'>
                            <div class="error-icon">
                                <img src="./../../../assets/error.png" alt="error" />
                            </div>
                            <span>{{pageConstants[destination.error.optionSelect]}}</span>
                        </div>
                    </div>
                </div>
                <!------  END :: DESTINATION FIELD ----->
                <!------  START :: LASTNAME FIELD ----->

                <div class="form-group lastName-wrap">
                    <label for="reservation-look-up-lastName">
                        {{ pageConstants[lastName.label] }}
                        <span *ngIf="lastName.isRequired" class="required">({{ commonConstants?.required }})</span>
                    </label>
                    <input type="text" class="form-control" id="reservation-look-up-lastName" [placeholder]="lastNamePlaceHolder"
                        formControlName="lastName" autocomplete="off" [maxlength]="lastName.maxLength" 
                        (focus) = "isLastNameInputFocused = true" (blur) = "isLastNameInputFocused = false"/>
                    <div class="error-block" *ngIf="lastNameControl?.dirty && lastNameControl?.invalid">
                        <div class="err-message" *ngIf="lastNameControl?.errors?.required" [attr.role]= "isLastNameInputFocused ? 'alert': ''">
                            <div class="error-icon">
                                <img src="./../../../assets/error.png" alt="error" />
                            </div>
                            <span>{{ pageConstants[lastName.required]}}</span>
                        </div>
                        <div class="err-message" *ngIf="lastNameControl?.errors?.pattern"  [attr.role]= "isLastNameInputFocused ? 'alert': ''">
                            <div class="error-icon">
                                <img src="./../../../assets/error.png" alt="error" />
                            </div>
                            <span>{{ pageConstants[lastName.error] }}</span>
                        </div>
                    </div>
                </div>
                <!------  END :: LASTNAME FIELD ----->
                <!------  START :: LASTNAME FIELD ----->

                <!------  START :: DATE OF BIRTH FIELD ----->
                <div class="form-group dob-wrap">
                    <label for="dob">
                        {{ pageConstants[dateOfBirth.label] }}
                        <span *ngIf="dateOfBirth.isRequired" class="required">({{ commonConstants?.required }})</span>
                    </label>
                    <div class="dob-fields-wrap" formGroupName="dateOfBirth">
                        <!------  START :: MONTH FIELD ----->
                        <select class="form-control inline month" formControlName="month" id='dob'>
                            <option value="" disabled hidden>Month</option>
                            <option *ngFor="let month of months" [value]="month.value">{{month.name}}</option>

                        </select>
                        <!------  END :: MONTH FIELD ----->
                        <!------  START :: DAY FIELD ----->
                        <input id="day" [attr.aria-label]="pageConstants.birthDate" type="number" autocomplete="off" class="form-control inline day"
                            formControlName="day" [placeholder]="dateOfBirth.day.placeholder"
                            [min]="dateOfBirth.day.minValue" [max]="dateOfBirth.day.maxValue"
                            (keydown)="restrictInvalidChars($event)"
                            (keypress)="limitChars(dateOfBirth.day.maxLength,$event)"
                            (keyup)="resetMaxValue(dayControl,dateOfBirth.day.maxValue)"
                            [attr.aria-label] = "pageConstants.birthDay" />
                        <!------  END :: DAY FIELD ----->
                        <!------  START :: YEAR FIELD ----->
                        <input id="year" type="number" formControlName="year" class="form-control inline year"
                            autocomplete="off" [min]="dateOfBirth.year.minValue" [max]="dateOfBirth.year.maxValue"
                            [placeholder]="dateOfBirth.year.placeholder" (keydown)="restrictInvalidChars($event)"
                            (keypress)="limitChars(dateOfBirth.year.maxLength,$event)"
                            (keyup)="resetMaxValue(yearControl,dateOfBirth.year.maxValue)"
                            [attr.aria-label] = "pageConstants.birthYear" 
                            (focus)= "isYearFieldFocused = true" (blur) = "isYearFieldFocused = false" />

                        <div *ngIf="!dateOfBirthFormControl.dirty" class="_placeholder">
                            <span>{{pageConstants[dateOfBirth.placeholder]}}</span>
                        </div>

                        <!------  END :: YEAR FIELD ----->
                        <!------  START :: DATE FIELD ERROR BLOCK ----->
                        <div class="error-block" *ngIf="dayControl?.dirty && dayControl?.invalid">
                            <div class="err-message" *ngIf="dayControl?.errors?.required" role='alert'>
                                <div class="error-icon">
                                    <img src="./../../../assets/error.png" alt="error" />
                                </div>
                                <span>{{ pageConstants[dateOfBirth.day.required] }}</span>
                            </div>
                            <div class="err-message" *ngIf="dayControl?.errors?.pattern" role='alert'>
                                <div class="error-icon">
                                    <img src="./../../../assets/error.png" alt="error" />
                                </div>
                                <span>{{ pageConstants[dateOfBirth.day.error] }}</span>
                            </div>
                        </div>
                        <div class="error-block" *ngIf="yearControl?.dirty && yearControl?.invalid && !isYearFieldFocused">
                            <div class="err-message" *ngIf="yearControl?.errors?.required" role='alert'>
                                <div class="error-icon">
                                    <img src="./../../../assets/error.png" alt="error" />
                                </div>
                                <span>{{ pageConstants[dateOfBirth.year.required] }}</span>
                            </div>
                            <div class="err-message"
                                *ngIf="yearControl?.errors?.pattern || yearControl?.errors?.max || yearControl?.errors?.min" role='alert'>
                                <div class="error-icon">
                                    <img src="./../../../assets/error.png" alt="error" />
                                </div>
                                <span>{{ pageConstants[dateOfBirth.year.error] }}</span>
                            </div>
                        </div>
                        <div class="error-block"
                            *ngIf="dateOfBirthFormControl?.dirty && dateOfBirthFormControl?.invalid && !yearControl?.invalid && !dayControl?.invalid">
                            <div class="err-message" *ngIf="dateOfBirthFormControl?.errors?.invalidDate" role='alert'> 
                                <div class="error-icon">
                                    <img src="./../../../assets/error.png" alt="error" />
                                </div>
                                <span>{{ pageConstants[dateOfBirth.error] }}</span>
                            </div>
                        </div>
                        <!------  END :: DATE FIELD ERROR BLOCK ----->
                    </div>
                </div>
                <!------  END :: DATE OF BIRTH FIELD ----->
                <div class="privacy-block">
                    <p>{{pageConstants.privacyLabel }} <a alt="Customer Data Privacy Policy" target="_blank"
                            href="//www.united.com/ual/en/us/fly/privacy.html">{{ pageConstants.privacyPolicy }}</a>. {{
                        pageConstants.privacyDesc }}</p>
                </div>
            </div>
            <!------  END :: FORM ELEMENTS ----->
            <!------  START :: SUBMIT BUTTON ----->
            <div class="btn-wrap row">
                <button [disabled]="flightSearchForm.invalid && isLoading"
                    [class.disabled]="flightSearchForm.invalid && isLoading" class="btn col-sm-8 col-md-6 col-lg-4">
                    {{ commonConstants["submit"] }}
                </button>
            </div>
            <!------  END :: SUBMIT BUTTON ----->
        </form>
    </div>
</div>